import { HttpClient } from '@angular/common/http';
import { ConnectorReservationDo } from '@api/reservation/dto/connector-reservation.do';
import { buildUrl } from '@utils/url/url.util';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RESTServerRoute } from '../../types/Server';
import { ReservationSettings } from '../../types/Setting';

@Injectable()
export class ReservationApiService {
  public constructor(private httpClient: HttpClient) {}

  public getReservation(chargingStationId: string, connectorId: number): Observable<ConnectorReservationDo> {
    const url = buildUrl(RESTServerRoute.REST_GET_RESERVATION, {
      chargerId: chargingStationId,
      connectorId: connectorId.toString(),
    });
    return this.httpClient.get<ConnectorReservationDo>(url);
  }

  public getReservationSettings(): Observable<ReservationSettings> {
    return this.httpClient.get<ReservationSettings>(RESTServerRoute.REST_RESERVATION_SETTINGS);
  }

  public updateReservationSettings(settings: { ReservationDuration: number }): Observable<ReservationSettings> {
    return this.httpClient.put<ReservationSettings>(RESTServerRoute.REST_RESERVATION_SETTINGS, {
      ReservationDuration: settings.ReservationDuration,
    });
  }
}
